export const EMERGE_WEBSITE = 'https://www.emerge.nz';
export const XERO_PARTNERSHIP_EMERGE = 'https://www.xero.com/nz/partnerships/emerge/';
export const EMERGE_MOBILE_TERMS_CONDITIONS = 'https://www.emerge.nz/mobile-terms-conditions';
export const EMERGE_MOBILE_PRIVACY_POLICY = 'https://www.emerge.nz/mobile-privacy-policy';
export const EMERGE_LOGIN = 'https://www.emerge.nz/login';
export const EMERGE_HELP_FMT_XERO_CONNECTION =
  'https://intercom.help/emerge/en/articles/15468541-connect-your-fmt-account-to-xero';
export const EMERGE_HELP_BATCH_PAYMENTS =
  'https://intercom.help/emerge/en/articles/17276036-create-and-manage-batch-payments-in-emerge';
